'use client';

import React, { useState, useEffect } from 'react';
import RoomHero from './RoomHero';
import PhotoGallery from './PhotoGallery';
import RoomFeatures from './RoomFeatures';
import RoomStory from './RoomStory';
import TestimonialsSection from './TestimonialsSection';
import BookingWidget from './BookingWidget';
import RelatedRooms from './RelatedRooms';

const StanzaDellaTraveInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:21:6" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="21" data-component-end-line="30" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%22%7D" className="min-h-screen bg-background">
        <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:22:8" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="22" data-component-end-line="29" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22animate-pulse%22%7D" className="animate-pulse">
          <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:23:10" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="23" data-component-end-line="23" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-96%20bg-muted%22%7D" className="h-96 bg-muted"></div>
          <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:24:10" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="24" data-component-end-line="28" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-4%20py-16%22%7D" className="max-w-7xl mx-auto px-4 py-16">
            <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:25:12" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="25" data-component-end-line="25" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-8%20bg-muted%20rounded%20mb-4%22%7D" className="h-8 bg-muted rounded mb-4"></div>
            <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:26:12" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="26" data-component-end-line="26" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-4%20bg-muted%20rounded%20mb-2%22%7D" className="h-4 bg-muted rounded mb-2"></div>
            <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:27:12" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="27" data-component-end-line="27" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-4%20bg-muted%20rounded%20w-3%2F4%22%7D" className="h-4 bg-muted rounded w-3/4"></div>
          </div>
        </div>
      </div>);

  }

  // Mock data for Stanza della Trave
  const roomData = {
    name: "Stanza della Trave",
    subtitle: "Eleganza moderna con carattere storico",
    description: "Una camera spaziosa e luminosa che combina il fascino della trave in legno originale con tutti i comfort moderni. Perfetta per chi cerca un ambiente accogliente nel cuore di Bergamo.",
    mainImage: "/assets/images/rooms/stanza-della-trave/gallery-0.jpg",
    mainImageAlt: "Elegante camera da letto con trave in legno a vista, letto matrimoniale con biancheria bianca e arredamento moderno",
    features: [
    "Trave in legno originale",
    "Scrivania professionale",
    "WiFi ad alta velocità",
    "Aria condizionata",
    "TV Smart 32\"",
    "Bagno privato moderno"],

    pricePerNight: 85
  };

  const photos = [
  {
    id: 1,
    src: "/assets/images/rooms/stanza-della-trave/gallery-1.jpg",
    alt: "Camera principale con trave in legno a vista e letto matrimoniale con biancheria bianca",
    category: "Camera"
  },
  {
    id: 2,
    src: "/assets/images/rooms/stanza-della-trave/gallery-3.jpg",
    alt: "Scrivania moderna in legno con sedia ergonomica e lampada da lavoro",
    category: "Camera"
  },
  {
    id: 3,
    src: "/assets/images/rooms/stanza-della-trave/gallery-2.jpg",
    alt: "Bagno moderno con doccia in vetro, lavandino sospeso e specchio illuminato",
    category: "Bagno"
  },
  {
    id: 4,
    src: "/assets/images/bg/stazione.jpeg",
    alt: "a pocchi minuti della stazione",
    category: "Dettagli"
  },
  {
    id: 5,
    src: "/assets/images/bg/vista.jpg",
    alt: "Vista dalla finestra sui tetti storici di Bergamo con campanili sullo sfondo",
    category: "Vista"
  },
  {
    id: 6,
    src: "/assets/images/bg/sala-1.jpg",
    alt: "Angolo relax con poltrona moderna e tavolino per il tè",
    category: "Dettagli"
  }];


  const features = [
  {
    icon: "WifiIcon",
    title: "WiFi Professionale",
    description: "Connessione ad alta velocità fino a 100 Mbps, perfetta per videochiamate e lavoro remoto."
  },
  {
    icon: "ComputerDesktopIcon",
    title: "Postazione Lavoro",
    description: "Scrivania ergonomica con illuminazione dedicata e prese multiple per tutti i dispositivi."
  },
  {
    icon: "TvIcon",
    title: "Smart TV 32\"",
    description: "Televisore Smart con accesso a Netflix, Prime Video e tutte le principali piattaforme."
  },
  {
    icon: "SparklesIcon",
    title: "Aria Condizionata",
    description: "Sistema di climatizzazione silenzioso per il massimo comfort in ogni stagione."
  },
  {
    icon: "HomeModernIcon",
    title: "Design Moderno",
    description: "Arredamento contemporaneo che rispetta il carattere storico dell'edificio."
  },
 ];


  const roomStory = {
    title: "La Storia della Trave",
    subtitle: "Un pezzo di storia bergamasca",
    content: [
    "La maestosa trave in legno che caratterizza questa camera risale al XVII secolo, quando questo edificio era parte del quartiere artigianale di Bergamo. Ogni venatura del legno racconta secoli di storia, dalle botteghe medievali alle moderne esigenze del business travel.",
    "Durante i lavori di restauro, abbiamo scelto di preservare e valorizzare questo elemento architettonico unico, integrandolo armoniosamente con i comfort moderni. La trave non è solo un elemento decorativo, ma il simbolo della nostra filosofia: rispettare il passato abbracciando il futuro.",
    "Oggi, sotto questa stessa trave che ha visto passare generazioni di bergamaschi, accogliamo viaggiatori da tutto il mondo, offrendo loro un'esperienza autentica nel cuore pulsante della città."],

    image: "https://images.unsplash.com/photo-1649408532430-df1568679cc9",
    imageAlt: "Dettaglio ravvicinato della trave in legno antico con venature naturali e illuminazione moderna"
  };

  const testimonials = [
  {
    id: 1,
    name: "Marco Rossi",
  
    company: "''",
    rating: 5,
    comment: "Perfetta per i miei viaggi di lavoro. La posizione strategica e la qualità del WiFi hanno reso il mio soggiorno estremamente produttivo. La trave antica aggiunge un tocco di classe unico.",
    avatar: "/assets/images/testimonials/avatar-2.png",
    avatarAlt: "Ritratto professionale di uomo d\'affari in giacca blu con sorriso sicuro",
    date: "Novembre 2025"
  },
  {
    id: 2,
    name: "Laura Bianchi",
    
    company: "''",
    rating: 5,
    comment: "Ho soggiornato qui durante una settimana di meeting a Milano. La connessione ferroviaria è impeccabile e la camera offre tutto ciò che serve per lavorare comodamente. Servizio impeccabile!",
    avatar: "/assets/images/testimonials/avatar-2.png",
    avatarAlt: "Ritratto professionale di donna d'affari con capelli castani e blazer nero",
    date: "Ottobre 2025"
  },
  {
    id: 3,
    name: "Alessandro Conti",
    
    company: "''",
    rating: 5,
    comment: "La combinazione perfetta tra storia e modernità. La scrivania è perfetta per le videochiamate e l'atmosfera della camera aiuta a rilassarsi dopo giornate intense di lavoro.",
    avatar: "/assets/images/testimonials/avatar-2.png",
    avatarAlt: "Ritratto professionale di giovane manager con barba e camicia bianca",
    date: "Settembre 2025"
  }];


  const relatedRooms = [
  {
    id: 1,
    name: "Santa Margherita",
    subtitle: "Romantica e accogliente",
    description: "Camera matrimoniale con atmosfera intima, perfetta per coppie e soggiorni romantici nel cuore di Bergamo.",
    image: "/assets/images/rooms/santa-margherita/gallery-0.jpg",
    imageAlt: "Camera romantica con letto matrimoniale, decorazioni floreali e illuminazione soffusa",
    pricePerNight: 150,
    features: ["Letto matrimoniale", "tv", "Decorazioni italiane", "Atmosfera Tranquilla"],
    href: "/room-santa-margherita"
  }];


  return (
    <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:183:4" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="183" data-component-end-line="203" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%22%7D" className="min-h-screen bg-background">
      <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:184:6" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="184" data-component-end-line="202" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20lg%3Agrid-cols-4%20gap-8%20max-w-7xl%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="grid lg:grid-cols-4 gap-8 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Content */}
        <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:186:8" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="186" data-component-end-line="194" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-3%22%7D" className="lg:col-span-3">
          <RoomHero data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:187:10" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="187" data-component-end-line="187" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="RoomHero" data-component-content="%7B%22elementName%22%3A%22RoomHero%22%7D" room={roomData} />
          <PhotoGallery data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:188:10" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="188" data-component-end-line="188" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="PhotoGallery" data-component-content="%7B%22elementName%22%3A%22PhotoGallery%22%7D" photos={photos} />
          <RoomFeatures data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:189:10" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="189" data-component-end-line="189" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="RoomFeatures" data-component-content="%7B%22elementName%22%3A%22RoomFeatures%22%7D" features={features} />
        
          <RoomStory data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:191:10" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="191" data-component-end-line="191" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="RoomStory" data-component-content="%7B%22elementName%22%3A%22RoomStory%22%7D" story={roomStory} />
          <TestimonialsSection data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:192:10" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="192" data-component-end-line="192" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="TestimonialsSection" data-component-content="%7B%22elementName%22%3A%22TestimonialsSection%22%7D" testimonials={testimonials} />
          <RelatedRooms data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:193:10" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="193" data-component-end-line="193" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="RelatedRooms" data-component-content="%7B%22elementName%22%3A%22RelatedRooms%22%7D" rooms={relatedRooms} />
        </div>

        {/* Sidebar with Booking Widget */}
        <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:197:8" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="197" data-component-end-line="201" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-1%22%7D" className="lg:col-span-1">
          <div data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:198:10" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="198" data-component-end-line="200" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Apl-8%22%7D" className="lg:pl-8">
            <BookingWidget data-component-id="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx:199:12" data-component-path="src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx" data-component-line="199" data-component-end-line="199" data-component-file="StanzaDellaTraveInteractive.tsx" data-component-name="BookingWidget" data-component-content="%7B%22elementName%22%3A%22BookingWidget%22%7D" pricePerNight={roomData?.pricePerNight} availability={true} />
          </div>
        </div>
      </div>
    </div>);

};

export default StanzaDellaTraveInteractive;
